import { Observable, forkJoin } from "rxjs";
import { BaseRequestModel } from "../utils/axios.ts";
import { Body, Method } from "../utils/types";


export const ApiService = {
  call: (route: string, method: Method, body: Body, headers?: any): Observable<any> => {
    const token = localStorage.getItem("token");
    const loginTime = localStorage.getItem("InititalTimeStamp");
    const isIframe = localStorage.getItem('isIframe');
    if (loginTime && isIframe) {
      const date1 = new Date(loginTime);
      const date2 = new Date();
      const diffInMs = Math.abs(date2.getTime() - date1.getTime());
      const diffInMinutes = Math.floor(diffInMs / 60000);
      // const diffInSeconds = Math.floor((diffInMs % 60000) / 1000);
      if (diffInMinutes > 4) {
        window.parent.postMessage(
          {
            type: "Token_Auth_Check",
            payload: {
              message: "Auctive Auth Check",
              tokenTimeDifference: diffInMinutes
            },
          },
          'https://proteanapp.com'//process.env.REACT_APP_PROTEAN_APP_URL ?? ''
        );
        localStorage.setItem('InititalTimeStamp', date2.toString());
      } else {
        localStorage.setItem('InititalTimeStamp', date2.toString());
      }
    }
    let url = route;
     
    if (window.location.href.includes("localhost")) {
      url = `https://devapiinventoryvariance.proteanapp.com/api/${route}`;
    } else {
      url = `https://apiinventoryvariance.proteanapp.com/api/${route}`;
    }

    const requestHeader = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      ...headers,
    };

    const newBase = new BaseRequestModel(url, method, body, requestHeader);
    return newBase.request();
  },
};
